import { DialogComponent } from '@theme/dialog';

class ParfumLoyaltyPopup extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('parfum-loyalty:open', this.#handleOpen);
    
    // Support data-close-popup attribute
    this.addEventListener('click', (event) => {
      if (event.target.hasAttribute('data-close-popup') || event.target.closest('[data-close-popup]')) {
        this.close();
      }
    });

    // Automatic appearance after 5 seconds
    this.#initAutoOpen();
  }

  #initAutoOpen() {
    const isLoggedIn = this.getAttribute('data-logged-in') === 'true';
    const hasShownInSession = sessionStorage.getItem('maison-loyalty-popup-shown');
    const isUrlTriggered = window.location.hash === '#loyalty' || window.location.search.includes('loyalty_preview=true');

    if (isUrlTriggered) {
      this.open();
      return;
    }

    if (isLoggedIn || hasShownInSession) return;

    setTimeout(() => {
      this.open();
      sessionStorage.setItem('maison-loyalty-popup-shown', 'true');
    }, 5000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('parfum-loyalty:open', this.#handleOpen);
  }

  #handleOpen = () => {
    this.showDialog();
  };

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('parfum-loyalty-popup')) {
  customElements.define('parfum-loyalty-popup', ParfumLoyaltyPopup);
}
